"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFileboy = useFileboy;
exports.useMaybeFileboy = useMaybeFileboy;
exports.FileboyProvider = FileboyProvider;
var react_1 = __importStar(require("react"));
var constants_1 = require("./constants");
var client_1 = require("./client");
var errors_1 = require("./errors");
var FileboyContext = react_1.default.createContext({});
var DEFAULT_NAMESPACE = "__DEFAULT_NAMESPACE__";
/**
 * Access the current fileboy context, returning a fileboy client.
 *
 * @param namespace - Optionally specify which fileboy context to access, if you have multiple.
 * @returns A fileboy client.
 */
function useFileboy(namespace) {
    if (namespace === void 0) { namespace = DEFAULT_NAMESPACE; }
    var namespaces = (0, react_1.useContext)(FileboyContext);
    var value = namespaces[namespace];
    if (!value) {
        throw (0, errors_1.applicationError)("You must use the FileboyProvider.");
    }
    return value;
}
/**
 * Access the current fileboy context, returning a fileboy client or null if no provider is present.
 *
 * @param namespace - Optionally specify which fileboy context to access, if you have multiple.
 * @returns A fileboy client or null if no provider is present.
 */
function useMaybeFileboy(namespace) {
    if (namespace === void 0) { namespace = DEFAULT_NAMESPACE; }
    var namespaces = (0, react_1.useContext)(FileboyContext);
    var value = namespaces[namespace];
    return value || null;
}
/** Create a fileboy context, allowing child components to call useFileboy(). */
function FileboyProvider(_a) {
    var _b;
    var publicKey = _a.publicKey, _c = _a.namespace, namespace = _c === void 0 ? DEFAULT_NAMESPACE : _c, _d = _a.apiUrl, apiUrl = _d === void 0 ? constants_1.API_URL : _d, fetchMethod = _a.fetchMethod, children = _a.children;
    var currentNamespaces = (0, react_1.useContext)(FileboyContext);
    var client = new client_1.FileboyClient({ apiUrl: apiUrl, fetchMethod: fetchMethod, publicKey: publicKey });
    var value = {
        client: client,
        apiUrl: apiUrl,
        publicKey: publicKey,
        buildImageUrl: client.buildImageUrl.bind(client),
        buildFileUrl: client.buildFileUrl.bind(client),
        getFileData: client.getFileData.bind(client),
        searchFileData: client.searchFileData.bind(client),
        uploadFile: client.uploadFile.bind(client),
        uploadFileFromUrl: client.uploadFileFromUrl.bind(client),
    };
    return (react_1.default.createElement(FileboyContext.Provider, { value: __assign(__assign({}, currentNamespaces), (_b = {}, _b[namespace] = value, _b)) }, children));
}
